export default __webpack_public_path__ + "static/snabbaste-uttagsmetoderna-a9c31a5e218f319e411cdaf9f8ce102a.jpg";